import { all, takeEvery, takeLatest, put } from 'redux-saga/effects'
import { notification } from 'antd'
import { request } from '../../../../../admincore'

import { destroyLabel } from '../../../api'
import actions from './actions'

// const getCompanySelect = state => state.companySelect

function* DESTROY({ payload: { id } }) {
  const companySelect = localStorage.getItem('app.settings.company')

  if (!companySelect || companySelect === -1) {
    return
  }
  yield put(request(destroyLabel(companySelect, id), actions.DESTROY))
}

function* SUCCESS({ intl }) {
  yield notification.success({
    message: intl.formatMessage({ id: 'common.notifications.done' }),
    description: intl.formatMessage({ id: 'settings.labels.notifications.removed' }),
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.DESTROY, DESTROY), takeLatest(actions.DESTROY_SUCCESS, SUCCESS)])
}
